<template>
    <div id="main" style="width: 100%; height: 99%;"></div>
</template>

<script>

export default {
    name: 'SalesChart',
    components: {

    },
    props: {
        data: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            chart: null,
            option: {

                tooltip: {
                    trigger: 'axis'
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        color: 'white'
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(255, 255, 255,0.2)', // 竖线颜色
                            width: 2 // 竖线宽度
                        }
                    },
                    data: ['1月', '2月', '3月', '4月', '5月', '6月',
                        '7月', '8月', '9月', '10月', '11月', '12月']
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}',
                        color: 'white'
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(255, 255, 255,0.2)', // 竖线颜色
                            width: 2 // 竖线宽度
                        }
                    },
                    // 新增 splitLine 配置
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(255, 255, 255, 0.2)', // 竖线颜色
                            type: 'dashed' // 竖线样式，这里使用虚线
                        }
                    }
                },
                series: [{
                    name: '销售额',
                    type: 'bar',
                    data: [], // 根据你的数据调整
                    smooth: true,
                    lineStyle: {
                        color: '#5470C6',
                        width: 3
                    },
                    itemStyle: {
                        color: '#0088F0',

                    },
                    barWidth: 30,
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#5470C6' // 100% 处的颜色
                            }, {
                                offset: 1, color: 'rgba(84, 112, 198, 0.1)' // 0% 处的颜色
                            }]
                        }
                    }
                },
                {
                    name: '完成率',
                    type: 'line',
                    data: [], // 这里需要根据实际数据调整
                    smooth: true,
                    lineStyle: {
                        color: '#FD8A2A', // 线条颜色
                        width: 2
                    },
                    itemStyle: {
                        color: '#FD8A2A'
                    }
                },
                {
                    name: '完成率',
                    type: 'line',
                    data: [], // 这里需要根据实际数据调整
                    smooth: true,
                    lineStyle: {
                        color: '#14D85D', // 线条颜色
                        width: 2
                    },
                    itemStyle: {
                        color: '#14D85D'
                    }
                }]

            }
        }
    },
    mounted() {
        this.chart = this.$echarts.init(document.getElementById('main'));
        this.chart.setOption(this.option);
    },
    watch: {
        data(newValue) {
            if (!newValue) return
            if (newValue.length == 0) return
            //初始化12个月
            let xAxisData = []
            for (let i = 1; i <= 12; i++) {
                if (i < 10)
                    xAxisData.push('0' + i)
                else
                    xAxisData.push(i)

            }

            let newData = []
            let newData2 = []
            let lng=0;
            xAxisData.forEach(item => {
                if(lng==newValue.Current.length){
                    return;
                }

                let cData = newValue.Current.find(x => x.OperDate == item)

                if (cData != undefined) {

                    newData.push(cData.SaleAmount || 0)
                    newData2.push(cData.Persent * 100)
                    lng++;
                }
                else {
                    newData.push(0)
                    newData2.push(0)
                }

            });

            let newData3 = []
            if (newValue.Compare.length == 0) {
                for (let i = 1; i <= 12; i++) {
                    newData3.push(0)
                }
            } else {
                xAxisData.forEach(item => {

                    let cData = newValue.Compare.find(x => x.OperDate == item)
                    if (cData != undefined) {
                        newData3.push(cData.Persent * 100)
                    }
                    else {
                        newData3.push(0)
                    }
                })
            }

            this.option.series[0].data = newData
            this.option.series[1].data = newData2
            this.option.series[2].data = newData3
            this.chart.setOption(this.option);
        }
    },
    methods: {

    }
}
</script>
<style lang="less"></style>